import React from "react";
import ReactDOM from "react-dom/client";
import { hydrateRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import "@/index.css";
import App from "@/App";
import { Toaster } from "@/components/ui/sonner";

const rootEl = document.getElementById("root");

const tree = (
  <React.StrictMode>
    <HelmetProvider>
      <App />
      <Toaster />
    </HelmetProvider>
  </React.StrictMode>
);

// If react-snap pre-rendered HTML into #root at build time, hydrate it.
// Otherwise mount normally.
if (rootEl.hasChildNodes()) {
  hydrateRoot(rootEl, tree);
} else {
  const root = ReactDOM.createRoot(rootEl);
  root.render(tree);
}
